export class ChatSessionService {
  private readonly _storageKey = 'pilgrim-chat-widget-session-id';

  getSessionId(): string | null {
    return localStorage.getItem(this._storageKey);
  }

  getOrCreateSessionId(): string {
    const currentSessionId = this.getSessionId();

    if (currentSessionId) {
      return currentSessionId;
    }

    const newSessionId = crypto.randomUUID();
    localStorage.setItem(this._storageKey, newSessionId);

    return newSessionId;
  }

  resetSession(): string {
    const newSessionId = crypto.randomUUID();
    localStorage.setItem(this._storageKey, newSessionId);

    return newSessionId;
  }

  clearSession(): void {
    localStorage.removeItem(this._storageKey);
  }
}
